module.exports = __webpack_public_path__ + "img/facebook.6fa74b44.svg";